__turbopack_context__.v({
  "aboutHeroTitleGradient": "fJbI0G_aboutHeroTitleGradient",
  "descriptionAnimation": "fJbI0G_descriptionAnimation",
  "fadeInUp": "fJbI0G_fadeInUp",
  "imageAnimation": "fJbI0G_imageAnimation",
  "sectionAnimation": "fJbI0G_sectionAnimation",
  "titleAnimation": "fJbI0G_titleAnimation",
});
